module.exports = __webpack_public_path__ + "img/Responsiveness.d45bb09d.png";